
export const customMoldedRowData = [
  { title2: "0.00 to 0.39", comFix: "+/- .008", comClo: "+/-.013", precFix: "+/- .006", precClo: "+/- .008", highFix: "+/- .004", highClo: "+/- .005" },
  { title2: "0.40 to 0.63", comFix: "+/-.010", comClo: "+/-.016", precFix: "+/- .008", precClo: "+/- .010", highFix: "+/- .005", highClo: "+/- .006" },
  { title2: "0.64 to 0.99", comFix: "+/-.013", comClo: "+/-.020", precFix: "+/- .010", precClo: "+/- .013", highFix: "+/- .006", highClo: "+/- .008" },
  { title2: "1.00 to 1.59", comFix: "+/-.016", comClo: "+/-.025", precFix: "+/- .013", precClo: "+/- .016", highFix: "+/- .008", highClo: "+/- .010" },
  { title2: "1.60 to 2.49", comFix: "+/-.020", comClo: "+/-.032", precFix: "+/- .016", precClo: "+/- .020", highFix: "+/- .010", highClo: "+/- .013" },
  { title2: "2.50 to 3.99", comFix: "+/-.025", comClo: "+/-.040", precFix: "+/- .020", precClo: "+/- .025", highFix: "+/- .013", highClo: "+/- .016" },
  { title2: "4.00 to 6.29", comFix: "+/-.032", comClo: "+/-.050", precFix: "+/- .025", precClo: "+/- .032", highFix: "+/- .016", highClo: "+/- .020" },
];

export const customMoldedColDefs = [
  { field: 'title2', headerName: '', width: 130 },
  { field: 'comFix', headerName: 'Fixed Dimension', suppressMovable: true, initialPinned: "left", width: 150 },
  { field: 'comClo', headerName: 'Closure Dimension', width: 150 },
  { field: 'precFix', headerName: 'Fixed Dimension', width: 150, headerClass: ['ag-grid-border-right'], cellClass: ['ag-grid-border-right'] },
  { field: 'precClo', headerName: 'Closure Dimension', width: 150 },
  { field: 'highFix', headerName: 'Fixed Dimension', width: 150, headerClass: ['ag-grid-border-right'], cellClass: ['ag-grid-border-right'] },
  { field: 'highClo', headerName: 'Closure Dimension', width: 150 },
];

export const customMoldedAddHeaders = [
  { field: "title", headerName: "" },
  { field: "com", headerName: "Commercial Grade (Standard) RMA-A3 (Inches)", suppressMovable: true, initialPinned: "left", colSpan: 2  },
  { field: "prec", headerName: "Precision Grade RMA-A2 (Inches)", headerClass: ['ag-grid-border-right'], colSpan: 2 },
  { field: "high", headerName: "High Precision Grade RMA-A1", headerClass: ['ag-grid-border-right'], colSpan: 2 },
];
